import { z } from "zod/v4";

export const errorInfoSchema = z.object({
  message: z.string(),
  code: z.string().optional(),
  stack: z.string().optional(),
  details: z.record(z.string(), z.unknown()).optional(),
});

export type ErrorInfo = z.infer<typeof errorInfoSchema>;
